import { products, clouds } from "../../../../src/components/custom-story-json";
import * as React from 'react';
export default {
  products,
  clouds,
  React
};